"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConvertStyle_1 = __importDefault(require("Project/Service/TCDCProjectConverter/ConvertStyle"));
var DefaultStyles_1 = __importDefault(require("@CommonFrontendBackend/StyleService/DefaultStyles"));
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var PrepareStyles_1 = require("Project/Service/TCDCProjectConverter/PrepareStyles");
exports.default = (function (account, usingFeature, invoke, addDefaultTcdcStyle, brandStore) {
    var convertStyle = invoke(ConvertStyle_1.default);
    return function (block) {
        var blockNeedsTcdcStyle = block.style == null && block.settings && !!block.settings.style;
        var hasAlreadyPreparedStyles = false;
        if ((0, FeatureFlag_1.isUsingTCDC)(usingFeature) && blockNeedsTcdcStyle) {
            var matchingStyleToConvert = __spreadArray(__spreadArray([], __read(account.styles), false), __read(DefaultStyles_1.default), false).find(function (style) { return style.className === block.settings.style; });
            if (matchingStyleToConvert != null) {
                block.style = convertStyle(matchingStyleToConvert);
            }
            else {
                addDefaultTcdcStyle(block);
                hasAlreadyPreparedStyles = true;
            }
        }
        if ((0, FeatureFlag_1.isUsingTCDC)(usingFeature) && !hasAlreadyPreparedStyles && block.style) {
            (0, PrepareStyles_1.prepareStyle)(block.style, brandStore);
        }
    };
});
